/*
 * @Description: What's this for
 * @Autor: WangYuan
 * @Date: 2021-03-25 10:25:23
 * @LastEditors: WangYuan
 * @LastEditTime: 2021-12-15 17:17:02
 */
const TokenKey = 'token'
const UserInfoKey = 'user-info'
const ProjectKey = 'mall-project'
const CurPageKey = 'mall-cur-page'
const LastBuildPageByUserKey = 'mall-last-build-page-by-user'

export function getAuthToken() {
    return sessionStorage.getItem(TokenKey)
}

export function setAuthToken(token) {
    return sessionStorage.setItem(TokenKey, token)
}

export function removeAuthToken() {
    return sessionStorage.removeItem(TokenKey)
}

export function setAuthUserInfo(userInfo) {
    return sessionStorage.setItem(UserInfoKey, JSON.stringify(userInfo))
}

export function getAuthUserInfo() {
    let userInfoStr = sessionStorage.getItem(UserInfoKey)
    return userInfoStr ? JSON.parse(sessionStorage.getItem(UserInfoKey)) : null
}

export function removeAuthUserInfo() {
    return sessionStorage.removeItem(UserInfoKey)
}

export function getProject() {
    let str = localStorage.getItem(ProjectKey)
    return str ? JSON.parse(str) : null
}

export function settingProject(project) {
    return localStorage.setItem(ProjectKey, JSON.stringify(project))
}

export function removeProject() {
    return localStorage.removeItem(ProjectKey)
}

export function getCurPage() {
    let str = localStorage.getItem(CurPageKey)
    return str ? JSON.parse(str) : null
}   

export function setCurPage(page) {
    return localStorage.setItem(CurPageKey, JSON.stringify(page))
}

export function getLastBuildPage(userId) {
    if (!userId) return null
    let str = localStorage.getItem(LastBuildPageByUserKey)
    let map = str ? JSON.parse(str) : {}
    return map[userId] || null
}

export function setLastBuildPage(userId, page) {
    if (!userId || !page) return
    let str = localStorage.getItem(LastBuildPageByUserKey)
    let map = str ? JSON.parse(str) : {}
    map[userId] = {
        pageId: page.id,
        siteId: page.site
    }
    return localStorage.setItem(LastBuildPageByUserKey, JSON.stringify(map))
}

export function removeCurPage() {
    return localStorage.removeItem(CurPageKey)
}

export function clearLoginStorage() {
    const lastBuildPageByUser = localStorage.getItem(LastBuildPageByUserKey)
    sessionStorage.clear()
    localStorage.clear()
    if (lastBuildPageByUser) {
        localStorage.setItem(LastBuildPageByUserKey, lastBuildPageByUser)
    }
}
